import { useTranslation } from "react-i18next";
import { SelectPicker, Table, Toggle } from "rsuite";
import { displayField, getLabelFor } from "../../../utils/helpers";
import { genderObjArr } from "../../../core/config/AppConstants";
const { Cell } = Table;

const MasterEditCell = ({
  rowData,
  dataKey,
  onChange,
  ...props
}: {
  rowData?: any;
  dataKey?: any;
  onChange: Function;
}) => {
  const editing = rowData.editStatus === "EDIT";
  const { t } = useTranslation();
  return (
    <Cell {...props} className={editing ? "table-content-editing" : ""}>
      {(() => {
        if (editing && dataKey == "status")
          return (
            <Toggle
              defaultChecked={rowData[dataKey]}
              onChange={(value: any) => {
                onChange && onChange(rowData.id, dataKey, value);
              }}
            />
          );
        else if (editing && dataKey == "gender")
          return (
            <SelectPicker
              data={genderObjArr}
              valueKey="value"
              labelKey="label"
              onSelect={(value, item) => {
                onChange && onChange(rowData.id, dataKey, value);
              }}
              onClean={(e: any) => {
                onChange && onChange(rowData.id, dataKey, "");
              }}
              name="gender"
              value={rowData?.gender}
            />
          );
        else if (dataKey == "gender")
          return (
            <span className="table-content-edit-span">
              {displayField(getLabelFor(rowData?.gender, genderObjArr))}
            </span>
          );
        else if (editing && dataKey != "status")
          return (
            <input
              className="rs-input"
              defaultValue={rowData[dataKey]}
              onChange={(event: any) => {
                onChange && onChange(rowData.id, dataKey, event.target.value);
              }}
            />
          );
        else if (dataKey == "status")
          return (
            <span className="table-content-edit-span">
              {rowData[dataKey] == "1" ? t("ACTIVE") : t("INACTIVE")}
            </span>
          );
        else
          return (
            <span className="table-content-edit-span">{rowData[dataKey]}</span>
          );
      })()}
    </Cell>
  );
};

export default MasterEditCell;
